export default {
  init($element) {

  },
  finalize($element) {
    $(window).on('scroll', function() {
      if (($(window).scrollTop() + ($(window).innerHeight() / 2)) >= $element.offset().top) {
        $element.find('.lottie-home-solutions').each(function() {
          $(this).trigger('lottie-play');
        });
      }
    });

    // Set animated arrows height to initial height to prevent jumping
    $element.find('.animation-wrap').css({
      'height': $element.height(),
    });

    function showRelevantSolutions() {
      const $allSolutions = $element.find('.all-solutions');

      $allSolutions.find('.solution-item').addClass('d-none');

      var requirements = {};

      $element.find('.picker-choices .picker-choice').each(function() {
        const type = $(this).data('type');
        const slug = $(this).data('slug');
        requirements[type] = slug;
      });

      $allSolutions.find('.solution-item').each(function() {
        var matched = true;
        const taxs = $(this).data('taxs');

        taxs.forEach((tax) => {
          const taxName = tax.tax_name;
          const taxSlugs = tax.slugs;

          if (!taxSlugs.includes(requirements[taxName])) {
            matched = false;
          }
        });

        if (matched) {
          $(this).removeClass('d-none');
        }
      });
    }

    const $presentation = $element.find('.picker-presentation');

    $presentation.find('button.solution').on('click', function() {
      const type = $(this).parents('.presentation-slide').data('type');
      const slug = $(this).data('slug');
      const text = $(this).html();

      // Check if this is type is already a selection
      const $currentSelection = $element.find(`.picker-choices .picker-choice[data-type="${type}"]`);

      if ($currentSelection.length > 0) {
        $currentSelection.remove();
      }

      // Add this to the selections list
      const $newSelection = $(`<div class="btn picker-choice" data-type="${type}" data-slug="${slug}">${text}</div>`);
      $element.find('.picker-choices').addClass('show');
      $element.find('.picker-choices').append($newSelection);

      // Go to next slide
      const currentSlideIndex = $(this).parents('.presentation-slide').data('slide');
      const $thisSlide = $presentation.find(`.presentation-slide[data-slide="${currentSlideIndex}"]`);
      const $nextSlide = $presentation.find(`.presentation-slide[data-slide="${currentSlideIndex + 1}"]`);

      $thisSlide.removeClass('show');
      $thisSlide.addClass('queued');

      if ($nextSlide.data('type') == 'result') {
        showRelevantSolutions();
      }

      setTimeout(() => {
        $thisSlide.removeClass('queued');
        $nextSlide.addClass('show');
      }, 1000);
    });

    $presentation.find('.slide-return').on('click', function() {
      const currentSlideIndex = $(this).parents('.presentation-slide').data('slide');
      const $thisSlide = $presentation.find(`.presentation-slide[data-slide="${currentSlideIndex}"]`);
      const $prevSlide = $presentation.find(`.presentation-slide[data-slide="${currentSlideIndex - 1}"]`);

      $thisSlide.removeClass('show');
      $thisSlide.addClass('queued');

      setTimeout(() => {
        $thisSlide.removeClass('queued');
        $prevSlide.addClass('show');
      }, 1000);
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/home/solutionsPicker.js